import { combineReducers, Action } from 'redux';
import { dnListReducer } from './dispatchNotificationReducer';

export const dnModuleReducer = combineReducers({
  dnData : dnListReducer
})